<template>
  <v-slider
    id="tamSlider"
    :value="value"
    track-color="secondary"
    track-fill-color="primary"
    color="white"
    height="50"
    :min="min"
    :max="max"
    class="tam-slider pt-6 pt-sm-12 pr-2 pl-2"
    thumb-label="always"
    thumb-color="undefined"
    @input="$emit('input', $event)"
  >
    <template slot="thumb-label">
      <div class="pb-4">
        <div class="d-inline" :class="{ hidden: value <= min }">
          <span class="arrows three left"></span>
          <span class="arrows two left"></span>
          <span class="arrows one left"></span>
        </div>
        <div class="d-inline" :class="{ hidden: value >= max }">
          <span class="arrows one right"></span>
          <span class="arrows two right"></span>
          <span class="arrows three right"></span>
        </div>
      </div>
    </template>
  </v-slider>
</template>

<script>
export default {
  props: {
    value: {
      type: Number
    }
  },
  data() {
    return {
      min: 1,
      max: 1000
    }
  }
}
</script>

<style lang="scss">
.tam-slider {
  .v-slider {
    .v-slider__track-container {
      height: 32px !important;
      .v-slider__track-fill {
        border-radius: 10px;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      .v-slider__track-background {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
      }
    }
  }
  .v-slider__thumb {
    background-image: url('~@/assets/img/png/Briefcase.png') !important;
    background-size: contain !important;
    background-color: white !important;
    left: -31px !important;
    width: 62px !important;
    height: 50px !important;
    border-radius: 0 !important;
    &::before {
      width: unset !important;
      height: unset !important;
    }
    &:not(:hover) {
      animation: tilt-n-move-shaking 0.25s infinite, delay-animation 2s infinite;
    }
  }
  .v-slider__thumb-label {
    width: 150px !important;
    background-color: transparent !important;
  }
  .hidden {
    visibility: hidden;
  }
}

$arrow-color: black;
$arrow-size: 20px;
$arrow-thickness: 4px;

@keyframes tilt-n-move-shaking {
  0% {
    transform: translateY(-25px) rotate(0deg);
  }
  25% {
    transform: translateY(-25px) rotate(10deg);
  }
  50% {
    transform: translateY(-25px) rotate(0deg);
  }
  75% {
    transform: translateY(-25px) rotate(-10deg);
  }
}

@keyframes delay-animation {
  100% {
    transform: translateY(-25px) rotate(0deg);
  }
}

.arrows {
  display: inline-block;
  -ms-transform: rotate(-45deg); /* IE 9 */
  -webkit-transform: rotate(-45deg); /* Chrome, Safari, Opera */
  transform: rotate(-45deg);

  width: $arrow-size;
  height: $arrow-size;
}

.left {
  border-left: $arrow-thickness solid;
  border-top: $arrow-thickness solid;
}

.right {
  border-right: $arrow-thickness solid;
  border-bottom: $arrow-thickness solid;
}

.one,
.two,
.three {
  -webkit-animation: arrow-opacity 1s infinite;
  -moz-animation: arrow-opacity 1s infinite;
  animation: arrow-opacity 1s infinite;
  border-color: $arrow-color;
}

.one {
  -webkit-animation-delay: 0.1s;
  -moz-animation-delay: 0.1s;
  -webkit-animation-direction: alternate;

  animation-direction: alternate;
  animation-delay: alternate;
}

.two {
  -webkit-animation-delay: 0.2s;
  -moz-animation-delay: 0.2s;
  -webkit-animation-direction: alternate;

  animation-direction: alternate;
  animation-delay: 0.2s;
}

.three {
  -webkit-animation-delay: 0.3s;
  -moz-animation-delay: 0.3s;
  -webkit-animation-direction: alternate;

  animation-direction: alternate;
  animation-delay: 0.3s;
}

@-webkit-keyframes arrow-opacity {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}
@-moz-keyframes arrow-opacity {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}
@-o-keyframes arrow-opacity {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}
@keyframes arrow-opacity {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.8;
  }
}
</style>
